var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PreviewHistoryProcessModel',{ref:"previewHistoryDialog",attrs:{"canEdit":_vm.canEdit},on:{"close":_vm.close}})
}
var staticRenderFns = []

export { render, staticRenderFns }